module.exports = __webpack_public_path__ + "static/media/sprite.d92a111c.svg";